// pages/Privacy.js
import React from "react";

function Privacy() {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
      <h1>Privacy Policy</h1>
      <p>Effective Date: 2-25-25</p>
      
      <h2>1. Introduction</h2>
      <p>Welcome to VSN Michiagn. We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share your information when you use our services.</p>
      
      <h2>2. Information We Collect</h2>
      <p>We may collect personal information that you provide directly to us when signing up, booking appointments, or opting in to SMS notifications. This may include your name, email, phone number, and other relevant details.</p>
      
      <h2>3. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Provide and manage appointment scheduling services</li>
        <li>Send appointment confirmations, reminders, and updates via email or SMS</li>
        <li>Improve our services and customer experience</li>
        <li>Comply with legal obligations</li>
      </ul>
      
      <h2>4. SMS Communications</h2>
      <p>By opting in to SMS notifications, you consent to receive messages regarding your appointments. Message and data rates may apply. You can opt out at any time by replying STOP to any SMS.</p>
      
      <h2>5. Sharing Your Information</h2>
      <p>We do not sell or share your personal information with third parties except as required by law or to provide our services (e.g., sending SMS through a third-party provider).</p>
      
      <h2>6. Data Security</h2>
      <p>We take reasonable steps to protect your personal information from unauthorized access, loss, or misuse.</p>
      
      <h2>7. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated effective date.</p>
      
      <h2>8. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at pictures@vsnmichigan.com.</p>
    </div>
  );
}

export default Privacy;
